<script setup lang="ts">
const { t } = useI18n()

defineProps<{
  isOpen: boolean
  handleClose: (isOpen: boolean) => void
}>()

const emit = defineEmits<{ (e: 'onSave'): void; (e: 'onActivate'): void }>()
</script>

<template>
  <BaseModal :is-open="isOpen" size="lg" :show-footer="false" @close="handleClose(false)">
    <div class="flex w-full flex-row justify-center">
      <div class="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
        <BaseIcon name="HeroInformationCircleIconSolid" class="h-6 w-6 text-blue-500" />
      </div>
    </div>

    <p class="mt-5 text-center font-semibold">
      {{ t('pages.marketingFlow.marketingFlowEditPage.saveConfirmation') }}
    </p>

    <p class="mb-5 mt-2 text-sm text-foreground-secondary text-center">
      {{ t('pages.marketingFlow.marketingFlowEditPage.saveDisclaimer') }}
    </p>

    <div class="flex w-full flex-row justify-center">
      <Button variant="outline" class="mr-3 flex-1" @click="emit('onSave')">
        <span class="text-foreground">{{ t('pages.marketingFlow.marketingFlowEditPage.saveAndQuitButton') }}</span>
      </Button>

      <Button variant="default-primary" class="flex-1" @click="emit('onActivate')">
        {{ t('pages.marketingFlow.marketingFlowEditPage.activateScenario') }}
      </Button>
    </div>
  </BaseModal>
</template>
